fragment ContactLastContactedTimeFragment on Contact {
    id
    lastContactedTime
    myLastContactedTime
}
